import React from "react";
import { BASE_URL } from "../utils/constants";

interface Props {
  onClick?: () => void;
}

const style = {
  width: 80
};

export default function (props: Props) {
  return (
    <img
      src={`${BASE_URL}/img/logo.png`}
      alt="logo"
      style={style}
      onClick={props.onClick}
    />
  );
}
